module.exports = __webpack_public_path__ + "static/media/sa-stam-acasa.783aed9d.jpeg";